import { render, staticRenderFns } from "./finshed.vue?vue&type=template&id=fdbc4952"
import script from "./finshed.vue?vue&type=script&lang=js"
export * from "./finshed.vue?vue&type=script&lang=js"
import style0 from "./finshed.vue?vue&type=style&index=0&id=fdbc4952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports